import { define } from 'wicked-elements'

define('[data-component~="lazy-image"]', {
  init () {
    this.element.style.opacity = 0
    this.element.style.transition = 'opacity 0.5s'
    this.handleLoad = this.handleLoad.bind(this)
  },
  connected () {
    this.element.addEventListener('load', this.handleLoad)
    if (this.element.complete) this.handleLoad()
  },
  disconnected () {
    this.element.removeEventListener('load', this.handleLoad)
  },
  handleLoad () {
    this.element.style.removeProperty('opacity')
  }
})
